import { API_PRICE_LABEL_REPORT } from 'utils/constants'
import Api from './axiosInstance'

type FetchPriceLabelReportsParams = {
  limit: number
  page: number
  search?: string
  filters?: any
}

export const fetchPriceLabelReports = ({
  limit,
  page,
  search,
  filters,
}: FetchPriceLabelReportsParams) => {
  let options: any = {}

  if (search) {
    options.search = search
  }

  if (filters) {
    options = { ...options, ...filters }
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_PRICE_LABEL_REPORT.PRICE_LABEL_REPORT}?${params}`,
  })
}

export const exportPriceLabelReportData = async ({
  filters,
}: {
  filters: Record<string, any>
}) => {
  const params = new URLSearchParams(filters)

  return Api.get({
    url: `${API_PRICE_LABEL_REPORT.EXPORT}?${params}`,
  })
}
